<template>
  <div>
    <b-modal
      :ok-disabled="disabled"
      :cancel-disabled="disabled"
      ok-title="ثبت"
      cancel-title="لغو"
      id="add_bon_modal"
      title="تعیین بازه زمانی"
      @ok="submit"
    >
      <form
      autocomplete="off"
      @submit.prevent="submitHandler">
        <div class="row">
          <b-form-group class="col-12">
            <label for="title"> ارزش بن <i class="text-danger">*</i></label>
            <b-form-input
              id="title"
              ref="title"
              v-model="selectedValue"
            ></b-form-input>
          </b-form-group>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
import AddBonImpl from "@@/core/components/customerClub/addBon/AddBonImpl.js";
export default {
  extends: AddBonImpl,
};
</script>
